import { ReactNode } from 'react';

import { IBoostersInvoicePreviewResponse } from '@/shared/api/billing/types';
import { createModalStore } from '@/shared/lib/modal';

export type PromoCodeConfig = {
  enabled: boolean;
  planId: string;
};

export type PurchaseConfirmationModalData = {
  confirmButtonText?: string;
  currentPlan?: string;
  newPlan?: string;
  promoCodeConfig?: PromoCodeConfig;
  renderExtra?: () => ReactNode;
  fetchPreview: (promoCode?: null | string) => Promise<IBoostersInvoicePreviewResponse>;
  onCancel?: () => void;
  onConfirm: (invoice: IBoostersInvoicePreviewResponse, promoCode?: null | string) => Promise<void>;
};

export const usePurchaseConfirmationModalStore = createModalStore<PurchaseConfirmationModalData>();
